var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 19,
    viewBox: "0 0 5 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.503.939A1.884 1.884 0 0 0 .53 2.728v.184l.447 9.025c.026.79.71 1.42 1.526 1.368a1.43 1.43 0 0 0 1.368-1.368l.448-9.025c.026-1.026-.79-1.92-1.816-1.973zM1.003 18.357a1.971 1.971 0 1 0 2.79-2.789 1.971 1.971 0 1 0-2.79 2.79z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.29158790b36df376d249d0f3ed94a361.svg";
export { ForwardRef as ReactComponent };